import { ComponentTheme } from "hardcover-ui/types/base";

export type BadgeThemeProps = {
  variant: "accent" | "primary" | "secondary" | "success" | "warning" | "ghost";
  size: "sm" | "md" | "lg";
};

const badgeBaseStyles = "font-semibold whitespace-nowrap";

export const badgeTheme: ComponentTheme<BadgeThemeProps> = {
  variant: {
    primary: `${badgeBaseStyles} bg-primary text-primary-foreground`,
    accent: `${badgeBaseStyles} bg-accent text-accent-foreground`,
    secondary: `${badgeBaseStyles} bg-secondary text-secondary-foreground`,
    success: `${badgeBaseStyles} bg-success text-success-foreground`,
    warning: `${badgeBaseStyles} bg-destructive text-destructive-foreground`,
    ghost: `${badgeBaseStyles} bg-muted text-muted-foreground`,
  },
  size: {
    sm: "rounded-lg text-xs px-1 py-0.5",
    md: "rounded-lg text-sm px-1 py-0.5",
    lg: "rounded-lg text-base px-1.5 py-1",
  },
};
